import React from "react";
import { FormattedMessage } from "react-intl";
import { Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { FaSignOutAlt } from "react-icons/fa";
import { NavLinkProps } from "../../types";
import styles from "./styles.module.scss";
import messages from "./messages";

export interface Props {
  links: NavLinkProps[];
  isActiveLink: (index: number) => boolean;
  onLogoutClick: (event: React.SyntheticEvent<{}>) => void;
  showLogout: boolean;
}

const NavBar = ({ links, isActiveLink, onLogoutClick, showLogout }: Props) => {
  return (
    <div>
      <Menu className={styles.navbar} id="navbar">
        {showLogout &&
          links.map((link: NavLinkProps, index: number) => {
            return (
              <Menu.Item
                as={Link}
                key={`link-${index}`}
                id={`link-${index}`}
                active={isActiveLink(index)}
                {...link}
                className={classNames(styles.link)}
              />
            );
          })}
        {showLogout && (
          <Menu.Item
            className={styles.logout}
            id="logout"
            onClick={onLogoutClick}
            position="right"
          >
            <FormattedMessage {...messages.logout} /> <FaSignOutAlt />
          </Menu.Item>
        )}
      </Menu>
    </div>
  );
};

export default NavBar;
